/**
 * Severity levels for import and review findings, mirroring the workbook's
 * own Data Quality Review sheet.
 */
export const SEVERITIES = ['high', 'medium', 'low', 'info'];
export const FINDING_STATUSES = ['open', 'acknowledged', 'resolved', 'wont_fix'];
/** Language of a value, for bilingual content. */
export const LOCALES = ['en', 'he'];
export function isLocale(v) {
    return v === 'en' || v === 'he';
}
export const DIRECTION = { en: 'ltr', he: 'rtl' };
//# sourceMappingURL=validation.js.map